<template>
  <button :disabled="disabled" @click="click">{{label}}</button>
</template>

<script>
export default {
  name: 'Form',
  props: ['label', 'disabled', 'click']
}
</script>

<style lang="scss" scoped>
@import "../_variables";

button {
  font-family: 'Cabin', sans-serif;
  min-width: 50%;
  box-sizing: border-box;
  border: 1px solid rgba(102, 100, 108, 0.16);
  background-color: #EC6569;
  color: white;
  border-radius: 4px;
  padding: 16px;
  margin: 8px 0;
  cursor: pointer;
  align-self: flex-end;

  &:disabled {
    background-color: #7f8c8d;
  }
}
</style>
